import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export default function(ComposedComponent, shouldBeAuthed, redirect) {
    class Authentication extends React.Component {
        componentWillMount() {
            if(this.props.shouldRedirect) {
                this.context.router.push(redirect);
            }
        }

        componentWillUpdate(nextProps) {
            if(nextProps.shouldRedirect) {
                this.context.router.push(redirect);
            }
        }

        render() {
            return <ComposedComponent {...this.props} />
        }
    }

    function mapStateToProps(state) {
        const authenticated = state.auth.authenticated;
        return { shouldRedirect: authenticated !== shouldBeAuthed };
    }

    Authentication.contextTypes = {
        router: PropTypes.object
    };

    return connect(mapStateToProps, null, null, {withRef: true})(Authentication);
}


// WEBPACK FOOTER //
// ./src/components/HigherOrder/Auth.js